import slugify from "slugify";

/**
 * Slugify string
 * This tries to be as close to the Laravel slugify as possible
 * https://github.com/laravel/framework/blob/aad4521c6a5c91a8fc0b9acbc2362c281013daea/src/Illuminate/Support/Str.php#L931
 *
 * @param str
 */
export default function slugifyString(str: string) {
  let slug = slugify(str, {
    lower: true,

    remove: /[^-a-zA-Z0-9\s]/g,
  });

  // Convert all underscores into separator
  slug = slug.replace(/_/g, "-");

  // Replace @ with the word 'at'
  slug = slug.replace(/@/g, "at");

  return slug.trim();
}
